import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "info-alert"
};
const _hoisted_2 = {
  class: "info-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_icon, {
    icon: "information-outline",
    class: "info-icon"
  }), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.warningMessage), 1)]);
}